/**
 * Enum zum Unterscheiden von Privatkunden und Firmen bei der Nutzeridentifikation
 */
export enum CustomerType {
  PRIVATE,
  COMPANY
}
